import type { Template } from "@/types";

export const LA_03_H1_V2: Template[] = [
    {
        id: "la-03-h1v2-01",
        name: "LA 01 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 119, y: 98, width: 438, height: 288, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 53, width: 251, height: 378, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 53, width: 250, height: 378, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-02",
        name: "LA 02 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_02.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 70, y: 42, width: 264, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 42, width: 264, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 795, y: 98, width: 438, height: 288, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-03",
        name: "LA 03 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_03.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 53, y: 41, width: 306, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 367, y: 41, width: 620, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 995, y: 41, width: 305, height: 402, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-03-h1v2-04",
        name: "LA 04 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 53, y: 41, width: 306, height: 402, rotation: 0, imageRotation: 0 },       
            { id: "2", x: 367, y: 41, width: 305, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 41, width: 620, height: 402, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-05",
        name: "LA 05 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 38, y: 33, width: 598, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 801, y: 97, width: 210, height: 312, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 97, width: 209, height: 312, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-06",
        name: "LA 06 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 66, y: 60, width: 543, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 833, y: 110, width: 178, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 110, width: 177, height: 264, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-07",
        name: "LA 07 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_07.png",
        size: [1352, 483],
        style: {},
        slots: [       
            { id: "1", x: 59, y: 33, width: 276, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 33, width: 275, height: 418, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 62, width: 539, height: 360, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-08",
        name: "LA 08 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 81, y: 33, width: 275, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 364, y: 33, width: 624, height: 418, rotation: 0, imageRotation: 0 },
            { id: "3", x: 996, y: 33, width: 276, height: 418, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-09",
        name: "LA 09 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_09.png",
        size: [1352, 483],
        style: {},
        slots: [   
            { id: "1", x: 82, y: 84, width: 208, height: 315, rotation: 0, imageRotation: 0 },
            { id: "2", x: 298, y: 84, width: 207, height: 315, rotation: 0, imageRotation: 0 },
            { id: "3", x: 588, y: 0, width: 764, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-10",
        name: "LA 10 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h1_v2_10.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 160, y: 109, width: 174, height: 265, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 109, width: 174, height: 265, rotation: 0, imageRotation: 0 },
            { id: "3", x: 714, y: 39, width: 601, height: 406, rotation: 0, imageRotation: 0 }
        ],
    },
];

